import React from "react";
import { ClipboardListIcon } from "@heroicons/react/solid";

const Resume = () => {
  return (
    <div
      id="Resume"
      className="lg:w-1/2 mt-64 mb-4 text-justify mx-12 lg:mr-60 lg:ml-auto"
    >
      <div>
        <div className="table">
          <ClipboardListIcon className="h-5 w-5 mr-4 text-yellow_vs" />{" "}
          <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
            Resume
          </code>
          <div className="table-cell border-b border-b-[#e6f1ff] border-opacity-25 w-full"></div>
        </div>
      </div>
      <div className="text-[#a2aabc] text-lg mt-5">
        <div className="flex flex-row">
          <div className="w-1/4">
            <code className="text-yellow_vs">Education</code>
          </div>
          <div className="w-3/4">
            <code className="text-blue_vs">Istituto Istruzione Superiore A. Volta</code>
            <br />
            <code className="italic text-sm text-lightblue_vs">
             Information Technology Diploma
            </code>
            <br />
            <code className="text-xs text-brown_vs">
              • Sept 2013 - June 2019
            </code>
            <br />
            <br />
            <code className="text-blue_vs">Fondazione Jobs Academy,</code>
            <br />
            <code className="italic text-sm text-lightblue_vs">
             Web Designer & Software Development Diploma
            </code>
            <br />
            <code className="text-xs text-brown_vs">
              • Oct 2019 - Sept 2021
            </code>
          </div>
          
        </div>
        
        <div className="flex flex-row pt-10">
          <div className="w-1/4">
            <code className="text-yellow_vs">Work</code>
          </div>
          <div className="w-3/4">
            <code className="text-blue_vs">Data Processing Center Operator</code>
            <br />
            <code className="italic text-sm text-lightblue_vs">
              ASST Lodi - Lodi, Italy{" "}
            </code>
            <br />
            <code className="text-xs text-brown_vs">• June 2017 - July 2017</code>
            <br />
            <code className="text-sm">
              <br />• Use of company software for data collection.
              <br />• Tasks related to the use of Excel.
            </code>
            <br />
            <br />
            <code className="text-blue_vs">PCTO</code>
            <br />
            <code className="italic text-sm text-lightblue_vs">
              ZUCCHETTI S.P.A. - Lodi, Italy{" "}
            </code>
            <br />
            <code className="text-xs text-brown_vs">• Sept 2016 - June 2019</code>
            <br />
            <code className="text-sm">
              <br />• Training course within the school aimed at learning programming and management languages
                    servers (HTML, CSS, JAVA, Java script, PHP, MySQL).
            </code>
            <br />
            <br />
            <code className="text-blue_vs">Web Developer</code>
            <br />
            <code className="italic text-sm text-lightblue_vs">
              DIEFFETECH SRL - Lodi, Italy{" "}
            </code>
            <br />
            <code className="text-xs text-brown_vs">• Nov 2020 - July 2021</code>
            <br />
            <code className="text-sm">
              <br />• University internship aimed at learning business dynamics, programming languages ​​and frameworks:
                      Html, CSS, SASS, JS, PHP, YII2 (PHP framework).
            </code>
            <br />
            <br />
            <code className="text-blue_vs">Tutoring</code>
            <br />
            <code className="text-xs text-brown_vs">• Sept 2018 - Present</code>
            <br />
            <code className="text-sm">
              <br />• Private lessons for high school students (Computer Science, Math).
            </code>
            <br />
            <br />
            <code className="text-blue_vs">Web Designer - Freelance</code>
            
            <br />
            <code className="text-xs text-brown_vs">• Sept 2021 - Present</code>
            <br />
            
          </div>
        </div>
        <div className="flex flex-row pt-10 flex-wrap">
          <div className="w-1/4">
            <code className="text-yellow_vs">Skills</code>
          </div>
          <div className="w-3/4">
            <code className="text-sm">
              <br />• HTML
              <br />• Javascript
              <br />• React
              <br />• CSS
              <br />• SASS
              <br />• Angular
              <br />• PHP
              <br />• YII2
              <br />• JAVA
              <br />• SQL
              <br />• Wordpress
              <br />• Shopify
              <br />• Firebase
            </code>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
